import {Button, Menu, MenuButton, MenuItem, MenuList} from '@chakra-ui/react';
import {ChevronDownIcon} from "@chakra-ui/icons";
import useMediaQuery from '@mui/material/useMediaQuery';
import "./avatardropdownmenu.scss"

interface IAvatarDropdownMenu {
    profile: string
    name: string
    job: string
    menuItems: { title: string, action: () => void }[]
}

const AvatarDropdownMenu = ({profile, name, job, menuItems}: IAvatarDropdownMenu) => {
    const matches = useMediaQuery('(max-width:768px)');
    return (
        <div className="Avatar-Dropdown-Menu">
            <Menu>
                <MenuButton as={Button} rightIcon={<ChevronDownIcon/>}>
                    <div className="d-flex justify-content-start align-items-start">
                        <div className="img Avatar-Dropdown-Menu-Image-Box">
                            <img src={profile} alt="" className="img Avatar-Dropdown-Menu-Image"/>
                        </div>
                        {
                            matches ? null :
                                <div className="pe-3 ps-4 text-end">
                                    <span className="Avatar-Dropdown-Menu-Title">{name}</span>
                                    <br/>
                                    <span className="Avatar-Dropdown-Menu-Subtitle">{job}</span>
                                </div>
                        }
                    </div>
                </MenuButton>
                <MenuList>
                    {
                        menuItems.map((menuItem, index) => {
                            return (
                                <MenuItem key={index} onClick={menuItem.action}>{menuItem.title}</MenuItem>
                            );
                        })
                    }
                </MenuList>
            </Menu>
        </div>
    );
}

export default AvatarDropdownMenu